import qmath from "../stek/qmath";
import BContainer, { register_b_class, serialize_mat4 } from "./BBase";

const kPresetFloorColorList = [
	[78, 121, 200],
	[40, 190, 40],
	[225, 85, 110]
];

class BFloor extends BContainer {
	constructor(flags, forceSetId) {
		super(flags, forceSetId);
		this.title = "untitled";
		this.floorAltitude = 0;
		this.stackOrder = 0;

		this.editorColor = kPresetFloorColorList[0];

		this.itemTransform = new qmath.Mat4();
		this.useStandardDisplayItemAsRepresentative();
	}

	setEditorColorByPresetIndex(i) {
		this.editorColor = kPresetFloorColorList[i];
	}

	getEditorColorAsCSS(alpha, sat) {
		const c = [ ...this.editorColor ];

		if (Number.isFinite(sat)) {
			for (let i = 0;i < c.length;++i) {
				c[i] = c[i] * sat + (1.0-sat) * 128;
			}
		}

		if (Number.isFinite(alpha)) {
			return `rgba(${ c[0] },${ c[1] },${ c[2] },${ alpha })`;
		} else {
			return `rgb(${ c[0] },${ c[1] },${ c[2] })`;			
		}
	}

	setFloorAltitude(a) {
		this.floorAltitude = a;

		// update transform for this floor
		BFloor.setFloorAltTransform(this.itemTransform, a);
	}

	generateDisplayList(outList) {
		const selfRep = this.connectTransformTree(outList);
		selfRep?.copyToLocalTransform(this.itemTransform);
	}

	addItem(item) {
		super.addItem(item);
		if (item.setFloor) {
			item.setFloor(this);
		}
	}

	generateSignature() {
		return this.length;
	}

	serialize() {
		const o = super.serialize();

		o.title = this.title;
		o.floorAltitude = this.floorAltitude;
		o.editorColor = this.editorColor;
		o.itemTransform = serialize_mat4(this.itemTransform);

		return o;
	}

	deserialize(o) {
		this.title = o.title;
		this.floorAltitude = o.floorAltitude;
		this.editorColor = o.editorColor;
		this.itemTransform.importGL( o.itemTransform );
	}

	static setFloorAltTransform(mat, a) {
		return mat.translate3(0, 0, a);
	}
}

register_b_class(BFloor);
export { kPresetFloorColorList };
export default BFloor;